module.exports = __webpack_public_path__ + "static/media/home-grey.22197dee.svg";